<div id="carouselTipo1" class="carousel" data-bs-ride="carousel" data-bs-interval="false" *ngIf="isLoaded && slides.groups > 0">
    <div class="carousel-indicators">
      <!-- <button 

      type="button" data-bs-target="#carouselTipo1" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button> -->
      <div *ngFor="let group of [].constructor(slides.groups); let i = index">
            <button 
              type="button" 
              data-bs-slide-to="i"
              data-bs-target="#carouselTipo1" 
              [attr.data-bs-slide-to]="i" 
              [class.active]="i === 0" 
              [attr.aria-label]="'Slide ' + (i + 1)">
            </button>
          </div>
    </div>
    <div class="carousel-inner">


      <div *ngFor="let group of [].constructor(slides.groups); let i = index" 
           class="carousel-item" [class.active]="i === 0">

        <div class="col-lg-12 car-t1">
    
          <!-- Primera fila -->
          <div class="col-lg-12 car-t1-blq">
            <!-- Primer elemento -->
            <div class="col-lg-6 car-t1-blq" >
              <div class="col-lg-10 offset-lg-1 col-md-6 col-sm-6 col-6 car-t1-blq-inner px-0 py-2" *ngIf="groupedItems[i][0]">
                <img [src]="groupedItems[i][0]?.imgHomeUrl" alt="foto equipo" class="img-fluid">
                <span class="text-uppercase position-absolute top-50 start-50 translate-middle text-center">{{groupedItems[i][0]?.name}}</span>
              </div>
            </div>
            
            <!-- Segundo elemento -->
            <div class="col-lg-6 car-t1-blq" >
              <div class="col-lg-10 col-md-6 col-sm-6 col-6 car-t1-blq-inner px-0 py-2" *ngIf="groupedItems[i][1]">
                <img [src]="groupedItems[i][1]?.imgHomeUrl" alt="foto equipo" class="img-fluid">
                <span class="text-uppercase position-absolute top-50 start-50 translate-middle text-center">{{groupedItems[i][1]?.name}}</span>
              </div>
            </div>
          </div>
    
          <!-- Segunda fila -->
          <div class="col-lg-12 car-t1-blq">
            <!-- Tercer elemento -->
            <div class="col-lg-6 car-t1-blq" >
              <div class="col-lg-10 offset-lg-1 col-md-6 col-sm-6 col-6 car-t1-blq-inner px-0 py-2" *ngIf="groupedItems[i][2]">
                <img [src]="groupedItems[i][2]?.imgHomeUrl" alt="foto equipo" class="img-fluid">
                <span class="text-uppercase position-absolute top-50 start-50 translate-middle text-center">{{groupedItems[i][2]?.name}}</span>
              </div>
            </div>
            
            <!-- Cuarto elemento -->
            <div class="col-lg-6 car-t1-blq" >
              <div class="col-lg-10 col-md-6 col-sm-6 col-6 car-t1-blq-inner px-0 py-2" *ngIf="groupedItems[i][3]">
                <img [src]="groupedItems[i][3]?.imgHomeUrl" alt="foto equipo" class="img-fluid">
                <span class="text-uppercase position-absolute top-50 start-50 translate-middle text-center">{{groupedItems[i][3]?.name}}</span>
              </div>
            </div>
          </div>
    
        </div>
      </div>
    

</div>
    
</div>